module.exports = __webpack_public_path__ + "static/media/29ADMSPC17.893a3bb2.jpg";